var App;
// import Long  from "long";
// import * as protobuf from "@Lib/protobuf.js";
// protobuf.util.Long = Long
// protobuf.configure();

await import("./App.svelte").then((module) => {
  App = module.default;
  console.log(module);
});
const app = new App({
  target: document.body,
    props: {
    path: "//",
    name:"app"
  },
});

// recreate the whole app if an HMR update touches this module
if (import.meta["hot"]) {
  import.meta["hot"].dispose(() => {
    app.$destroy();
  });
  import.meta["hot"].accept();
}

export default app;

// import App from "./App.svelte";
// const app = new App({
//   target: document.body,
//   props: {
//     path: "//",
//     name:"app"
//   },
// });

// export default app;

// // recreate the whole app if an HMR update touches this module
// if (import.meta.hot) {
//   import.meta.hot.dispose(() => {
//     app.$destroy();
//   });
//   import.meta.hot.accept();
// }
